<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.payslipcondition') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <PayrollConditionForm
        :isSubmitted="isSubmitted"
        :disabled="disabled"
        :form.sync="form"
        :showActionButtons="hasRoleEdit"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapActions } from 'vuex'
import { PAYSLIP_CONDITION_TYPE } from '@/helpers/enum'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      loading: false,
      isSubmitted: false,
      disabled: false,
      form: null,
    }
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.payroll.title'),
      current: {
        app_name: 'payroll',
        app_id: 14,
        module_id: 3,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 1,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('payroll', {
      createCondition: 'createCondition',
    }),
    getData (form) {
      return {
        'type': form.type,
        'name': form.name,
        'is_increment': form.isIncrement,
        ...((() => {
          if (form.type !== PAYSLIP_CONDITION_TYPE.ADVANCED) {
            return null
          }
          return {
            'condition': {
              'variable': form.condition.variable,
              'operator': form.condition.operator,
              'value': form.condition.value,
              'if_true': form.condition.iftrue,
              'if_false': form.condition.iffalse,
            },
          }
        })()),
        'auto_apply_new_emp': form.autoApplyNewEmp,
      }
    },
    async handleSubmit (form = {}) {
      this.disabled = true
      this.isSubmitted = true
      const data = this.getData(form)
      const response = await this.createCondition(data)
      if (response.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: form.name }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({
          name: 'PaySlipConditionList',
          query: {
            ignoreDiscardAlert: true,
          },
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/payroll/condition/Create.vue